import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login';
import Header from './components/Header';
import { useDispatch } from 'react-redux'
import { useEffect } from 'react';
import { setUser } from './redux/features/authSlice';
import AddEditTour from './pages/AddEditTour';
import SingleTour from './pages/SingleTour';
import Dashboard from './pages/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import TagTours from './pages/TagTours';

function App() {
  const dispatch = useDispatch()

  const user = JSON.parse(localStorage.getItem('profile'))
  useEffect(() => {
    dispatch(setUser(user))
  }, [dispatch, user])
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/tours/search' element={<Home />} />
        <Route path='/tours/tag/:tag' element={<TagTours />} />
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route path='/addtour' element={<PrivateRoute><AddEditTour /></PrivateRoute>} />
        <Route path='/editTour/:id' element={<PrivateRoute><AddEditTour /></PrivateRoute>} />
        <Route path='/tour/:id' element={<SingleTour />} />
        <Route path='/dashboard' element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      </Routes>
      <ToastContainer />
    </div>
  );
}

export default App;

